import "./warrantyList.css";
import { Close } from "@material-ui/icons";
import { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    getWarranties,
    completeWarranty,
    deleteWarranty,
} from "../../redux/apiCalls";
import moment from "moment";
import { publicRequest } from "../../requestMethods";
import Select from "react-select";
import Table from "../../components/advancedTable";
const statusOptions = [
    {
        label: "Pending",
        value: "pending",
    },
    {
        label: "Approved",
        value: "approved",
    },
    {
        label: "Rejected",
        value: "rejected",
    },
    {
        label: "All",
        value: "",
    },
];

export default function WarrantyRequestList() {
    const dispatch = useDispatch();

    const manager = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "manager"
            : null
    );

    const staff = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.type === "staff" : null
    );

    const specialAccess = useSelector((state) =>
        state.user.currentUser
            ? ["64be53a291c85522064a711a", "6426333a94c2157f1ba818b9"].includes(
                  state.user.currentUser._id
              )
            : null
    );
    const principle = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.principle : null
    );
    const warranties = useSelector((state) => state.warranty.warranties);
    const [isLoaded, setIsLoaded] = useState(false);
    const [modalData, setModalData] = useState([]);
    const [warrantyData, setWarrantyData] = useState([]);
    const [returnWarrantyMenu, setReturnWarrantyMenu] = useState(false);
    const [completedWarrantyMenu, setCompletedWarrantyMenu] = useState(false);
    const [inputs, setInputs] = useState({
        model: "",
        userId: specialAccess
            ? "63429be7a4b0715d61b8955c"
            : manager
            ? principle
            : staff
            ? principle
            : undefined,
        limit: 20,
        page: 1,
        status: "pending",
        serialNumber: "",
        dateTo: undefined,
        dateFrom: undefined,
    });
    const [usersData, setUsersData] = useState([]);

    const getUsers = async () => {
        const res = await publicRequest.get("/users/admin", {
            params: { isAdmin: true },
        });
        setUsersData(res.data);
    };

    useEffect(() => {
        if (returnWarrantyMenu === true) {
            window.scroll(0, 0);
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [returnWarrantyMenu]);

    useEffect(() => {
        if (completedWarrantyMenu === true) {
            window.scroll(0, 0);
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [completedWarrantyMenu]);

    useEffect(() => {
        const fetchData = async () => {
            if (isLoaded === false) {
                try {
                    const result = await getWarranties(dispatch, inputs);
                    setWarrantyData(result.users);
                    setIsLoaded(true);
                } catch (error) {
                    console.error("Error fetching warranties:", error);
                }
            }
        };

        fetchData();
    }, [dispatch, inputs, warrantyData, isLoaded]);

    useEffect(() => {
        if (usersData[0] === undefined) {
            getUsers();
        }
    }, [usersData]);

    const handleReturn = ({ id }) => {
        deleteWarranty({ id }, dispatch);
    };

    const handleComplete = ({ id }) => {
        completeWarranty({ id }, dispatch);
    };

    const handleInputStatus = (e) => {
        setIsLoaded(false);
        setInputs((prev) => {
            return { ...prev, page: 1, status: e.value };
        });
    };

    const columns = useMemo(
        () => [
            {
                Header: "Attachment",
                accessor: "image", 
                width: 120,
                sortable: false,
                Cell: ({ value }) => (
                    <div className="flex justify-center">
                        {value ? (
                            <div 
                                className="relative group cursor-pointer"
                                onClick={() => window.open(value, '_blank')}
                            >
                                <img 
                                    className="w-12 h-12 rounded-lg object-cover shadow-lg border-2 border-slate-200 hover:border-blue-500 transition-all duration-300 transform group-hover:scale-110" 
                                    src={value} 
                                    alt="Warranty attachment"
                                />
                                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 rounded-lg transition-all duration-300 flex items-center justify-center pointer-events-none">
                                    <span className="text-white text-xs opacity-0 group-hover:opacity-100 transition-opacity duration-300">🔍 View</span>
                                </div>
                            </div>
                        ) : (
                            <div className="w-12 h-12 rounded-lg bg-slate-100 border-2 border-dashed border-slate-300 flex items-center justify-center">
                                <span className="text-slate-400 text-xs">No Image</span>
                            </div>
                        )}
                    </div>
                ),
            },
            {
                accessor: "message",
                Header: "Message",
                width: 800,
                sortable: false,
                Cell: ({ value }) => (
                    <div className="initialPadding">{value}</div>
                ),
            },
        
            {
                accessor: "order",
                Header: "Order",
                width: 200,
                sortable: false,
                Cell: ({ value }) => (
                    <div className="initialPadding">{value ? value.invoiceId : ""}</div>
                ),
            },
            {
                accessor: "user",
                Header: "User",
                width: 200,
                sortable: false,
                Cell: ({ value }) => (
                    <div className="initialPadding">{value ? value.name : ""}</div>
                ),
            },
            {
                accessor: "user.phoneNumber",
                Header: "Phone Number",
                width: 200,
                sortable: false,
                Cell: ({ value, row }) => (
                    <div className="initialPadding">{row.original.user ? row.original.user.phoneNumber : ""}</div>
                ),
            },
            {
                accessor: "createdAt",
                Header: "Request Date",
                width: 200,
                sortable: false,
                Cell: ({ value }) => (
                    <div className="initialPadding">
                        {moment(value).format("DD/MM/YYYY")}
                    </div>
                ),
            },
            {
                accessor: "status",
                Header: "Status",
                width: 150,
                sortable: false,
                Cell: ({ value }) => (
                    <div className="capitalize">{value}</div>
                ),
            },
            {
                accessor: "action",
                Header: "Action",
                width: 600,
                sortable: false,
                Cell: (params) => {
                    return (
                        <div className="flex items-center justify-center gap-2 whitespace-nowrap">
                            {params.row.original.status === "pending" ? (
                                <>
                                    <button
                                        className="px-6 py-2 bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white font-medium rounded-xl shadow-lg transition-all duration-300 transform hover:scale-105 hover:shadow-xl border border-green-500"
                                        onClick={() => {
                                            setModalData(
                                                params.row.original._id
                                            );
                                            setCompletedWarrantyMenu(true);
                                        }}
                                    >
                                        ✅ Accept
                                    </button>
                                    <button
                                        className="px-6 py-2 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-medium rounded-xl shadow-lg transition-all duration-300 transform hover:scale-105 hover:shadow-xl border border-red-500"
                                        onClick={() => {
                                            setModalData(
                                                params.row.original._id
                                            );
                                            setReturnWarrantyMenu(true);
                                        }}
                                    >
                                        ❌ Reject
                                    </button>
                                </>
                            ) : params.row.original.status === "in_progress" ? (
                                <button
                                    className="px-6 py-2 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-medium rounded-xl shadow-lg transition-all duration-300 transform hover:scale-105 hover:shadow-xl border border-blue-500"
                                    onClick={() => {
                                        setModalData(
                                            params.row.original._id
                                        );
                                        setCompletedWarrantyMenu(true);
                                    }}
                                >
                                    🏁 Complete
                                </button>
                            ) : (
                                <div className="text-slate-400 font-medium">No Action</div>
                            )}
                        </div>
                    );
                },
            },
        ],
        []
    );

    return (
        <div className="w-full bg-gradient-to-br from-slate-50 to-blue-50 min-h-screen">
            <div className="productList bg-white rounded-3xl shadow-2xl p-8 m-6 border border-slate-200/50">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
                    <div className="space-y-2">
                        <label className="text-sm font-semibold text-slate-700 tracking-wide">Request Status</label>
                        <div className="luxury-select-wrapper">
                            <Select
                                options={statusOptions.map((status, i) => {
                                    return {
                                        label: status.label,
                                        value: status.value,
                                    };
                                })}
                                onChange={handleInputStatus}
                                placeholder="Select Status"
                                defaultValue={{
                                    label: "Pending",
                                    value: "pending",
                                }}
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        background: 'linear-gradient(to right, rgb(248 250 252), rgb(239 246 255))',
                                        border: '2px solid rgb(226 232 240)',
                                        borderRadius: '12px',
                                        padding: '6px',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        boxShadow: 'none',
                                        '&:hover': {
                                            borderColor: 'rgb(59 130 246)',
                                        }
                                    }),
                                    option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isSelected ? 'rgb(59 130 246)' : state.isFocused ? 'rgb(239 246 255)' : 'white',
                                        color: state.isSelected ? 'white' : 'rgb(51 65 85)',
                                        fontWeight: '500',
                                        '&:hover': {
                                            backgroundColor: 'rgb(239 246 255)',
                                        }
                                    })
                                }}
                            />
                        </div>
                    </div>
                </div>

                {isLoaded && (
                    <Table
                        data={warrantyData}
                        columns={columns}
                        pageCount={Math.floor(warranties.totalPages / 20) + 2}
                        totalCount={warranties.totalPages}
                        updatePagination={setInputs}
                        paginationState={inputs}
                        updateLoaded={setIsLoaded}
                        hidePagination={inputs.limit === 20 ? false : true}
                    />
                )}
            </div>

            {returnWarrantyMenu && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => setReturnWarrantyMenu(false)}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Reject Warranty Request?
                                </h3>
                                <div className="flex justify-center gap-4 mt-6">
                                    <button
                                        className="px-6 py-2 bg-red-500 hover:bg-red-600 text-white font-medium rounded-lg transition-colors duration-200"
                                        onClick={() => {
                                            handleReturn({
                                                id: modalData,
                                            });
                                            setReturnWarrantyMenu(false);
                                        }}
                                    >
                                        Confirm Rejection
                                    </button>
                                    <button
                                        className="px-6 py-2 bg-gray-500 hover:bg-gray-600 text-white font-medium rounded-lg transition-colors duration-200"
                                        onClick={() => {
                                            setReturnWarrantyMenu(false);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {completedWarrantyMenu && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => setCompletedWarrantyMenu(false)}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Complete Warranty Request?
                                </h3>
                                <div className="flex justify-center gap-4 mt-6">
                                    <button
                                        className="px-6 py-2 bg-green-500 hover:bg-green-600 text-white font-medium rounded-lg transition-colors duration-200"
                                        onClick={() => {
                                            handleComplete({
                                                id: modalData,
                                            });
                                            setCompletedWarrantyMenu(false);
                                        }}
                                    >
                                        Confirm Acceptance
                                    </button>
                                    <button
                                        className="px-6 py-2 bg-gray-500 hover:bg-gray-600 text-white font-medium rounded-lg transition-colors duration-200"
                                        onClick={() => {
                                            setCompletedWarrantyMenu(false);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
} 